export type FieldLegalPersonType = {
  label: string;
  type: string;
};

export const FieldLegalPersonTypes: FieldLegalPersonType[] = [
  {
    label: "Libellé",
    type: "Label"
  },
  {
    label: "Mail",
    type: "Mail"
  },
  {
    label: "Confirmation de mail",
    type: "ConfirmMail"
  },
  {
    label: "Identifiant national",
    type: "NationalId"
  },
  {
    label: "Profession et spécialité",
    type: "ProfessionSpecialite"
  },
  {
    label: "Nom prénom du référant",
    type: "ReferringName"
  },
  {
    label: "Téléphone fixe",
    type: "Phone"
  },
  {
    label: "Téléphone du secrétariat",
    type: "DeskPhone"
  },
  {
    label: "Adresse",
    type: "Address"
  },
  {
    label: "Code postal",
    type: "PostalCode"
  },
  {
    label: "Ville",
    type: "City"
  }
];

export function getFieldLegalPersonType(
  type: string
): FieldLegalPersonType | undefined {
  return FieldLegalPersonTypes.find(ft => ft.type === type);
}
